import experiments from '@reverbdotcom/commons/src/experiments';
import { MParticlePageName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { Location } from 'history';
import { shouldShowTraitFiltersForRolledOutUser } from './map_params';

export const ALWAYS_TRACKED_EXPERIMENTS = [
  experiments.LISTING_CARD_LOCATION,
  experiments.DUMMY,
  experiments.MV_DUMMY_COOKIE_BUCKETING,
  experiments.MARKETPLACE_GRID_ADS,
  experiments.LISTINGS_QUERY_REWRITE_V2,
  experiments.LISTINGS_SEARCH_BEST_MATCH_SIGNALS_V3,
  experiments.LTS_V3_MARKETPLACE,
  experiments.AA_MARKETPLACE_SESSION_BUCKETING,
  experiments.PRICE_DROP_FILTER,
  experiments.SHOP_PAGE_PINNED_SEARCH,
  experiments.LIKELIHOOD_TO_SELL_V3_MARKETPLACE,
];

interface IPageViewTrackedExperimentsParams {
  location?: Location;
  pageName?: MParticlePageName;
}

export function pageViewTrackedExperiments({ location, pageName = MParticlePageName.Marketplace }: IPageViewTrackedExperimentsParams): string[] {
  const exps = [].concat(ALWAYS_TRACKED_EXPERIMENTS);

  if (shouldShowTraitFiltersForRolledOutUser(location?.query || {}, pageName)) {
    exps.push(experiments.TRAIT_FACETS_ELECTRIC_GUITARS);
  }

  if (pageName === MParticlePageName.Marketplace) {
    exps.push(experiments.USE_V2_LISTING_CARDS);
  }

  return exps;
}
